import React, { Component } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { Dimmer, Loader } from 'semantic-ui-react';
import { EventFormStore, EventFormViewModel } from 'stores/events/event-form-store';
import { connect } from 'redux-scaffolding-ts';

interface EventCommnetsContainerProps extends WithTranslation {
  selectedEventFormViewModel: EventFormViewModel;
  loading: boolean;
  readOnly: boolean;
  eventFormStore?: EventFormStore;
}

interface EventCommnetsContainerState {
  selectedEventFormViewModel: EventFormViewModel;
}

@connect(['eventFormStore', EventFormStore])
class EventCommnetsContainer extends Component<EventCommnetsContainerProps, EventCommnetsContainerState> {
  state: EventCommnetsContainerState = {
    selectedEventFormViewModel: this.props.selectedEventFormViewModel
  };

  private handleOnCommentChange(newComment: string) {
    const sEFVM = { ...this.state.selectedEventFormViewModel };
    sEFVM.comment = newComment;
    this.setState({ selectedEventFormViewModel: sEFVM });
    this.props.eventFormStore.change({ comment: newComment });
  }

  render() {
    const { t, readOnly } = this.props;
    const { comment } = this.state.selectedEventFormViewModel;

    return (
      <>
        {this.props.loading && (
          <div style={{ height: 200 }}>
            <Dimmer active inverted>
              <Loader size="large" active inverted />
            </Dimmer>
          </div>
        )}
        <div className="p-4">
          <div className="mb-3">
            <label className="block text-sm text-gray-700 mb-1">{t('Comments')}</label>
            <textarea
              className="w-full p-2 border border-gray-300 rounded"
              onChange={e => this.handleOnCommentChange(e.target.value as string)}
              value={comment}
              placeholder={t('Comments')}
              rows={4}
              disabled={readOnly}
            />
          </div>
        </div>
      </>
    );
  }
}
export default withTranslation()(EventCommnetsContainer);
